import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

export const FilterItem = ({ id, title, index, dragElement, isSelected, onChange }) => {
    const dragHandleRef = useRef(null);
    const itemRef = useRef(null);
    
    const [{ handlerId }, drop] = useDrop(
        () => ({
            accept: 'item',
            collect(monitor) {
                return {
                    handlerId: monitor.getHandlerId(),
                };
            },
            hover(item, monitor) {
                if (!itemRef.current) {
                    return;
                }
                const dragIndex = item.index;
                const hoverIndex = index;
                if (dragIndex === hoverIndex) {
                    return;
                }
                const hoverBoundingRect = itemRef.current?.getBoundingClientRect();
                const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                const clientOffset = monitor.getClientOffset();
                const hoverClientY = clientOffset.y - hoverBoundingRect.top;
                if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                    return;
                }
                if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                    return;
                }
                dragElement(dragIndex, hoverIndex);
                item.index = hoverIndex;
            },
        }),
        [index, dragElement]
    );
    
    const [{ isDragging }, drag] = useDrag(
        () => ({
            type: 'item',
            item: () => {
                return { id, index };
            },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
        }),
        [id, index]
    );
    
    // Attach drag to handle, drop to item
    drag(dragHandleRef);
    drop(itemRef);

    return (
        <li key={id} ref={itemRef} style={{ opacity: isDragging ? 0.5 : 1 }} className='flex flex-items-center'>
            <span
                className="drag-btn icon-svg icon-svg-drag-horizontal-2"
                ref={dragHandleRef}
                data-handler-id={handlerId}
            ></span>

            <label htmlFor={`option-${id}`} className='flex flex-items-center'>
                <input
                    id={`option-${id}`}
                    type="checkbox"
                    value={id}
                    checked={isSelected}
                    onChange={() => onChange(id)}
                />
                {title || id}
            </label>
        </li>
    );
};

export default FilterItem;
